<div class="w-full border-l-4 border-l-blue-700 bg-blue-50/30 px-6 py-4">
  <!-- Header -->
  <div class="mb-4 flex items-center justify-between">
    <h3 class="font-lato text-sm font-bold tracking-wide text-black uppercase">
      {{ title }}
    </h3>
    <button
      (click)="viewMore()"
      class="font-lato inline-flex cursor-pointer items-center gap-0.5 text-sm font-semibold text-blue-600 hover:underline focus:outline-none"
    >
      View More
      <mat-icon
        class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
        aria-hidden="true"
        >arrow_forward</mat-icon
      >
    </button>
  </div>

  <!-- Data grid -->
  <div class="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3 lg:grid-cols-4">
    @for (i of info; track $index) {
      <div class="flex flex-col">
        <span
          class="font-lato text-xs font-semibold tracking-wide text-black uppercase"
        >
          {{ i.title }}
        </span>
        <span class="font-lato mt-0.5">
          {{ i.value || '-' }}
        </span>
      </div>
    }

    @if (order.canceled) {
      <div class="flex flex-col">
        <span
          class="font-lato text-xs font-semibold tracking-wide text-black uppercase"
        >
          Cancellation date
        </span>
        <span class="font-lato mt-0.5">
          {{ order.cancel_date | date: 'yyyy-MM-dd' }}
        </span>
      </div>
    }
  </div>
</div>
